import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import Header from '../../pages/Shared/Header/Header';
import Footer from '../../pages/Shared/Footer/Footer';
import { useApp } from '../../contexts/AppContext';

const ProjectDetail = () => {
  const { isInitialLoad, setIsInitialLoad } = useApp();

  useEffect(() => {
    if (isInitialLoad) return;
    setIsInitialLoad(true);
  }, [isInitialLoad, setIsInitialLoad]);

  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState({});

  //fetch json data and setting it to a state
  useEffect(() => {
    fetch('/allProjectsData.json')
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
        setLoading(false);
        console.log(data);
        setProject(data[id - 1]);
        console.log(data[id - 1]);
        console.log(data[id - 1]?.client);
      });
  }, []);

  const handleLiveClick = () => {
    window.open(project?.site);
  };

  const handleClientClick = () => {
    window.open(project?.client);
  };

  const handleServerClick = () => {
    window.open(project?.server);
  };

  return (
    <>
      <Header></Header>
      <Container className='text-center mt-5'>
        <Row>
          <Col sm={6}>
            <h3 className='fw-bolder text-center mt-5'>
              Project Name:&nbsp;{project?.name}
            </h3>
            <p className='text-start mt-5 mb-4'>
              <span className='text-decoration-underline fw-bold'>
                Detail Description:
              </span>
              &nbsp;{project?.detailDescription}
            </p>
            <p className='text-start mt-5 mb-4'>
              <span className='text-decoration-underline fw-bold pb-5'>
                Technology:
              </span>
              &nbsp;{project?.technology}
            </p>

            <Button
              variant='danger'
              size='sm'
              className='mt-4 text-white fw-bold ms-3'
              onClick={handleLiveClick}
            >
              Live Website
            </Button>

            <Button
              variant='primary'
              size='sm'
              className='mt-4 text-white fw-bold ms-3'
              onClick={handleClientClick}
            >
              Client Code
            </Button>

            <Button
              variant='success'
              size='sm'
              className='mt-4 text-white fw-bold ms-3'
              onClick={handleServerClick}
            >
              Server Code
            </Button>
          </Col>
          <Col sm={6}>
            <Container className='p-3'>
              <figcaption className='fw-bold text-dark pb-3 fs-2 text-decoration-underline'>
                Screenshot 1
              </figcaption>
              <Image
                src={project?.detailImg1}
                className='text-center pb-3 h-50 w-100'
                fluid
              />
              <figcaption className='fw-bold text-dark fs-2 text-decoration-underline'>
                Screenshot 2
              </figcaption>
              <Image
                src={project?.detailImg2}
                className='text-center pb-3 h-50 w-100'
                fluid
              />
              <figcaption className='fw-bold text-dark fs-2 text-decoration-underline'>
                Screenshot 3
              </figcaption>
              <Image
                src={project?.detailImg3}
                className='text-center pb-3 h-50 w-100'
                fluid
              />
            </Container>
          </Col>
        </Row>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default ProjectDetail;
